
import React from "react";
import { Link, useLocation } from "react-router-dom";

const serviceAreas = [

  { label: "Sincan Koltuk Yıkama", path: "/sincan/sincan-koltuk-yikama" },
  { label: "Sincan Perde Yıkama", path: "/sincan/sincan-perde-yikama" },
  { label: "Sincan Yorgan Yıkama", path: "/sincan/sincan-yorgan-yikama" },
  { label: "Sincan Battaniye Yıkama", path: "/sincan/sincan-battaniye-yikama" },
  { label: "Sincan Yerinde Yıkama", path: "/sincan/sincan-yerinde-yikama" },
  { label: "Sincan Yatak Yıkama", path: "/sincan/sincan-yatak-yikama" }
];

const SincanServiceArea = () => {
  const location = useLocation();

  return (
    <div className="text-[#003132] mt-0 w-full">
      <h2 className="text-lg font-semibold mb-1 uppercase tracking-wide text-center">SİNCAN HİZMET TÜRLERİ</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full">
        {serviceAreas.map((area, index) => (
          <Link
            key={index}
            to={area.path}
            className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
              location.pathname === area.path
                ? "bg-green-700 text-white"
                : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
            }`}
          >
            {area.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SincanServiceArea;

